const LoadingView = () => {
  return (<div style={{ marginTop: 250 }}>
		<center><h1>CabEasy</h1></center>
	</div>)
}

export default LoadingView;
